































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment-timezone';
import HeaderHome from '../../components/headerhome.vue';
import Ajax from '../../lib/ajax'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import SearchTransferInput from '@/store/entities/transfer/searchTransferInput';

@Component({
  components: { HeaderHome,VueTimepicker },
})



export default class TransferSearch extends Vue {
  adultTransferCount: number = 1;
  childTransferCount: number = 0;
  infantTransferCount: number = 0;
  allRegions: any[] = [];
  fromRegion:any={};
  toRegion:any={};
  trfDateMenu: boolean = false;
  transferDate: string = null;
  nowDate: string = new Date().toISOString().slice(0, 10);
  transferHour:any={}
  newPrice: string;
  oldPrice: string;
searchId:string;
transferCount:number=-1;
transferResults:any[]=[];

transferPayment(id){
  this.$router.push('/transferPayment/'+this.searchId+"/"+id+"?currency="+this.currencyFormat)
}

 async created(){
  this.searchId = this.$route.params.id;
  this.getTransferResults(this.searchId);
  this.getRegions();
 }

 async getTransferResults(id){
  const response = await Ajax.get(
        '/api/services/app/Transfer/GetTransferSearchResults?input='+id
      );
      this.transferResults=response.data.result.items;
      
 }
 async changeTransferList() {
    await this.transferResults.map((x: any) => {
      debugger
        this.priceFormatter(x.price, x.currencyId).then(
          (res) => {
            debugger;
            x.price = res.total;
            x.currencyId = res.secondCurrencyId;
          }
        );
    });
  }
 async priceFormatter(price, currencyId) {
  console.log(this.newPrice);
  console.log(this.oldPrice);
    if (this.newPrice !== undefined && this.oldPrice === undefined) {
      const payload = {
        amount: price,
        firstCurrencyId: currencyId,
        secondCurrencyId: this.$store.state.currency.id,
      };
      const response = await Ajax.post(
        '/api/services/app/Booking/ConvertExchangeRate',
        payload
      );
      debugger;
      return response.data.result;
    }
    const payload = {
      amount: price,
      firstCurrencyId: currencyId,
      secondCurrencyId: this.newPrice,
    };
    const response = await Ajax.post(
      '/api/services/app/Booking/ConvertExchangeRate',
      payload
    );
    return response.data.result;
  }

get getLanguage(){
   return this.$root.$i18n.locale;
  }
  @Watch('currencyFormat', { immediate: true })
  onChangeCurrencyFormat(price, oldPrice) {
    this.newPrice = price;
    this.oldPrice = oldPrice;
    debugger;
    this.changeTransferList();
  }
  get currencyFormat() {
    
    return this.$store.state.currency.id;
  }

  set currencyFormat(value) {
    this.newPrice = value;
  }
searchTransfer(){

  let hour = this.transferHour["HH"]+":"+this.transferHour["mm"]

  var item = new SearchTransferInput();
  item.fromRegionId=this.fromRegion.id;
  item.toRegionId=this.toRegion.id;
  item.departureDate=this.transferDate;
  item.adultCount=this.adultTransferCount;
  item.childCount=this.childTransferCount;
  item.infantCount=this.infantTransferCount;
  item.currencyId=this.$store.state.currency.id;
  item.hour=hour;
  this.saveTransferSearch(item);

}

async getRegions(){
  const response = await Ajax.get(
        '/api/services/app/Transfer/GetRegions'
      );
  this.allRegions=response.data.result.items;
}

async saveTransferSearch(item){
  const response = await Ajax.post(
        '/api/services/app/Transfer/SaveTransferSearch',item
      );
  let id = response.data.result.id;
  let currencyId = this.$store.state.currency.id;
   this.$router.push('/transferSearch/'+id+'?currency='+currencyId)


}

  get getTransferDate() {
    return this.transferDate != null
      ? moment(this.transferDate).format('DD-MM-yyyy')
      : '';
  }





  get totalTransferPassengerCount() {
    return this.adultTransferCount + this.childTransferCount + this.infantTransferCount;
  }
  plusTransferAdultCount() {
    if (this.adultTransferCount < 9) this.adultTransferCount += 1;
  }

  minusTransferAdultCount() {
    if (this.adultTransferCount != 1) this.adultTransferCount -= 1;
  }

  plusTransferChildCount() {
    if (this.childTransferCount < 9) this.childTransferCount += 1;
  }
  minusTransferChildCount() {
    if (this.childTransferCount != 0) this.childTransferCount -= 1;
  }
  plusTransferInfantCount() {
    if (this.infantTransferCount < 9) this.infantTransferCount += 1;
  }
  minusTransferInfantCount() {
    if (this.infantTransferCount != 0) this.infantTransferCount -= 1;
  }

}


